import IMember from 'types/IMember'
import { SET_MEMBER, SET_MEMBER_TYPE } from '../const'

// 当前登录用户信息
export interface SET_MEMBERAction {
  type: SET_MEMBER_TYPE;
  data: IMember
}

export const setMember = (member: IMember): SET_MEMBERAction => ({
  type: SET_MEMBER,
  data: member
})

